import {getAdobeMCVisitorID, getAdobeVisitorData} from '@adv-mt/mt-segment-wrapper'

const isNumber = string => {
  const stringWithoutSpaces = string.replace(/\s+/g, '')
  const phone = Number(stringWithoutSpaces)
  return !isNaN(phone)
}

const getAdobeData = async () => {
  const [{trackingServer: adobeTrackingServer, version: adobeVersion = ''}, adobeMarketingCloudVisitorId] =
    await Promise.all([getAdobeVisitorData(), getAdobeMCVisitorID()])

  return {
    adobeMarketingCloudVisitorId: adobeMarketingCloudVisitorId || '',
    adobeTrackingServer,
    adobeVersion
  }
}

const getReferrer = () => {
  return window?.document?.referrer && document.referrer !== '' ? document.referrer.split('/')[2] : ''
}

const getBrowserData = () => ({url: window.location.href, referrer: getReferrer()})

/**
 * This is a client Data that we need to send to our domain.
 */
const getAdobeTrackingParams = async () => {
  const {url, referrer} = getBrowserData()
  const {adobeMarketingCloudVisitorId, adobeTrackingServer, adobeVersion} = await getAdobeData()

  return {
    url,
    referrer,
    adobeMarketingCloudVisitorId,
    adobeTrackingServer,
    adobeVersion
  }
}

const mapTrackData = ({extendedLeadTrackingData, trackingData: {event, data = {}}, products = [], hitOrigin} = {}) => ({
  event,
  data: {
    ...data,
    ...extendedLeadTrackingData,
    ...(products.length > 0 && {products}),
    ...(hitOrigin && {hit_origin: hitOrigin})
  }
})

const formatPhone = rawPhone => {
  const joiner = ' '
  const phone = rawPhone.replace(/\s/g, '')

  const initPart = phone.substring(0, 3)
  const middlePart = phone.substring(3, 6)
  const finalPart = phone.substring(6, phone.length)
  return [initPart, middlePart, finalPart].join(joiner)
}

export {getAdobeTrackingParams, isNumber, mapTrackData, formatPhone}
